import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

// Context Providers
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';

// Layout
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import RoomsPage from './pages/RoomsPage';
import DiningPage from './pages/DiningPage';
import SpaPage from './pages/SpaPage';
import PoolPage from './pages/PoolPage';
import EntertainmentPage from './pages/EntertainmentPage';
import KidsPage from './pages/KidsPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';

// Admin Pages
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/about" element={<Layout><AboutPage /></Layout>} />
              <Route path="/rooms" element={<Layout><RoomsPage /></Layout>} />
              <Route path="/dining" element={<Layout><DiningPage /></Layout>} />
              <Route path="/spa" element={<Layout><SpaPage /></Layout>} />
              <Route path="/pool" element={<Layout><PoolPage /></Layout>} />
              <Route path="/entertainment" element={<Layout><EntertainmentPage /></Layout>} />
              <Route path="/kids" element={<Layout><KidsPage /></Layout>} />
              <Route path="/gallery" element={<Layout><GalleryPage /></Layout>} />
              <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/admin" element={<AdminLoginPage />} />
            </Routes>
          </BrowserRouter>
        </SettingsProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
